import { RevaluationType } from 'further-types/lp/revaluation';

export const RevaluationTypeLabels = {
  [RevaluationType.InitialInvestment]: 'Initial investment',
  [RevaluationType.Revaluation]: 'Revaluation',
};
